import type { VotesQuery } from "@artists/gql/design-challenges"

import type { EntryWithVote } from "./votes.types"

export const normalizeEntry = (
	entry: Maybe<
		VotesQuery["challengeEntriesForVoting"]["results"]["entries"][number]
	>,
): Nullable<EntryWithVote> => {
	if (!entry) return null

	return {
		...entry,
		entryImage: entry.image[entry.product.startsWith("Fabric") ? "L" : "M"],
	}
}
